import { useUpdateMemo } from "./use-update-memo";
import { useViewData } from "../view-data";
import { useViewModel } from "../view-model";

import type * as Repository from "../../../_repository";

type Props = {
	option: Repository.Query.QueryData.OptionPmsList.Option;
};

export const useInitialized = ({ option }: Props) => {
	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({ option });

	/**
	 * ViewModel の生成
	 */
	const {
		//
		viewModel,
		//
		// メモの変更
		onChangeMemo,
	} = useViewModel({ option });

	const {
		// メモの更新
		onUpdateMemo,
	} = useUpdateMemo({ option, viewModel });

	return {
		//
		viewData,
		//
		viewModel,
		// メモの変更
		onChangeMemo,
		//
		// メモの更新
		onUpdateMemo,
	};
};
